module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA6BAMAAAD8VzwlAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACRQTFRFAAAAGHhIG31HG35HG35HIIBAG35GGn5HGIBIG35GEHBAG35H8+iiXAAAAAx0Uk5TACC/3/8Qz98g7xDPJFXiPwAAAH1JREFUeJxjYBgFdABCAvhkGU0M8UkLuzjj0c5o4uKCRztrigte7WEuNNVegl97O37tHENGezkmqHRBaHfBAQzxS0O145J2b8ArXYHXaVDN2IAwQjMWAEpww0/zYryaubbg1byaEs2gZIZbMyiZ4dEM0o5PMwNDEz7NowAMAG/8W6l57ZxJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/arrow.png
// module id = y6xv
// module chunks = 34